import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import DatePicker from 'react-bootstrap-date-picker';
import { Modal } from 'react-bootstrap';

class TeamsAdd extends Component {

  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      date_start: '',
      date_finish: '',
      location: '',
      observation: '',
      presence: null,
      type: null,
      status: null,
      payment_status: null,
      report_dangerous_articles: null,
      training_id: null,
      lista_treinamentos: [],
      info_modal: [],
      sigtrip_training_ids: [],
      sigmec_training_ids: [],
      modal: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleChangeDateStartPicker = this.handleChangeDateStartPicker.bind(this);
    this.handleChangeDateFinishPicker = this.handleChangeDateFinishPicker.bind(this);

    this.adicionar = this.adicionar.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChangeTrainingNumber(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChangeDateStartPicker(value, formattedValue) {
    this.setState({
      date_start: value,
      date_start_str: formattedValue,
    });
  }
  handleChangeDateFinishPicker(value, formattedValue) {
    this.setState({
      date_finish: value,
      date_finish_str: formattedValue,
    });
  }


  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  

  handleSelectChangeTraining(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    this.handleAlert('', '', 'open');
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/info/treinamento/' + event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({info_modal: responseJson.data, modal: true});
        }
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });

  }
  
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }


  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/sigtrip/treinamentos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/turmas');
        if (responseJson.status === 'success') {
          self.setState({sigtrip_treinamentos_lista: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/sigmec/treinamentos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({sigmec_treinamentos_lista: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamentos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_treinamentos: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); }); });
    });
  }

  adicionar(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.name,
      date_start: this.state.date_start_str,
      date_finish: this.state.date_finish_str,
      location: this.state.location,
      observation: this.state.observation,
      presence: this.state.presence,
      type: this.state.type,
      status: this.state.status,
      payment_status: this.state.payment_status,
      report_dangerous_articles: this.state.report_dangerous_articles,
      training_id: this.state.training_id,
      sigtrip_training_ids: this.state.sigtrip_training_ids,
      sigmec_training_ids: this.state.sigmec_training_ids,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/turma/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar turma</h3>
      <Link to="/turmas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.adicionar}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome da turma:</label>
              <input required type="text" name="name" className="form-control" placeholder="Nome da turma" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Localidade:</label>
              <input required type="text" name="location" className="form-control" placeholder="Localidade" value={this.state.location} onChange={this.handleChange.bind(this, 'location')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Data de início:</label>
              <DatePicker onChange={this.handleChangeDateStartPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data de início" value={this.state.date_start} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Data de término:</label>
              <DatePicker onChange={this.handleChangeDateFinishPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data de término" value={this.state.date_finish} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Tipo de presença:</label>
              <Select
                className="form-field-name"
                name="presence"
                value={this.state.presence}
                searchable={true}
                required
                placeholder={'Selecione o tipo de presença'}
                onChange={this.handleSelectChange.bind(this, 'presence')}
                options={[
                  {value: "presencial", label: "Presencial"},
                  {value: "ead", label: "EAD"},
                  {value: "semipresencial", label: "Semipresencial"},
                ]}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Público:</label>
              <Select
                className="form-field-name"
                name="type"
                value={this.state.type}
                searchable={true}
                required
                placeholder={'Selecione o público'}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={[
                  {value: "interna", label: "Interna"},
                  {value: "externa", label: "Externa"},
                  {value: "mista", label: "Mista"},
                ]}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Número de Comunicação de Treinamento SIGTRIP:</label>
              <Select
                className="form-field-name"
                name="sigtrip_training_ids"
                value={this.state.sigtrip_training_ids}
                searchable={true}
                multi={true}
                placeholder={'Selecione os números de comunicado'}
                onChange={this.handleSelectChangeTrainingNumber.bind(this, 'sigtrip_training_ids')}
                options={this.state.sigtrip_treinamentos_lista}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Número de Comunicação de Treinamento SIGMEC:</label>
              <Select
                className="form-field-name"
                name="sigmec_training_ids"
                value={this.state.sigmec_training_ids}
                searchable={true}
                multi={true}
                placeholder={'Selecione os números de comunicado'}
                onChange={this.handleSelectChangeTrainingNumber.bind(this, 'sigmec_training_ids')}
                options={this.state.sigmec_treinamentos_lista}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Treinamento:</label>
              <Select
                className="form-field-name"
                name="training_id"
                value={this.state.training_id}
                searchable={true}
                placeholder={'Selecione o público'}
                onChange={this.handleSelectChangeTraining.bind(this, 'training_id')}
                options={this.state.lista_treinamentos}
                required
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Status do pagamento:</label>
              <Select
                className="form-field-name"
                name="payment_status"
                value={this.state.payment_status}
                searchable={true}
                required
                placeholder={'Selecione o status do pagamento'}
                onChange={this.handleSelectChange.bind(this, 'payment_status')}
                options={[
                  {value: "nao_cobrado", label: "Não cobrado"},
                  {value: "nao_aplicavel", label: "Não Aplicável"},
                  {value: "cobrado", label: "Cobrado"},
                  {value: "pago", label: "Pago"},
                ]}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Relatório de artigos perigosos:</label>
              <Select
                className="form-field-name"
                name="report_dangerous_articles"
                value={this.state.report_dangerous_articles}
                searchable={true}
                required
                placeholder={'Selecione uma opção'}
                onChange={this.handleSelectChange.bind(this, 'report_dangerous_articles')}
                options={[
                  {value: "nao_aplicavel", label: "Não Aplicável"},
                  {value: "enviado", label: "Enviado"},
                  {value: "nao_enviado", label: "Não Enviado"},
                  {value: "obrigatorio", label: "Obrigatório"},
                ]}
              />    
            </div>
          </div>
        </div>
        <div className="form-group">
          <label>Observações:</label>
          <textarea style={{ height: 200 }} type="text" name="observation" className="form-control" value={this.state.observation} onChange={this.handleChange.bind(this, 'observation')} />
        </div>
        <button className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar turma</button>
      </form>
      <Modal show={self.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'medium'}>
        <Modal.Header>
          <h4 className="pull-left">Informações de treinamentos</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.setState({ modal: false, info_modal: {} })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-stripped table-hover table-bordered">
            <thead>
              <tr>
                <th>Matéria</th>
                <th>Dificuldade</th>
                <th>Quantidade</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(self.state.info_modal).map(function(k) {
                return (
                  <tr>
                    <td>{self.state.info_modal[k].materia}</td>
                    <td>{self.state.info_modal[k].nivel}</td>
                    <td>{self.state.info_modal[k].qtd}</td>
                  </tr>                
                );
              })}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.setState({ modal: false, info_modal: {} })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default TeamsAdd;



// WEBPACK FOOTER //
// ./src/Components/Teams/TeamsAdd.js